var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade-fast", appear: "" } }, [
    _c(
      "div",
      {
        ref: "container",
        class: {
          "b-modal": true,
          mobile: _vm.isMobile,
          scrollable: _vm.isActuallyScrollable,
          dark: _vm.darkBackground,
          large: _vm.large,
          small: _vm.small,
          "no-radius": _vm.noBorderRadius,
          "refer-modal": _vm.isReferralModal,
          paywall: _vm.paywall,
          legal: _vm.legal
        },
        style: _vm.modalStyle,
        on: { click: _vm.onClick }
      },
      [
        _c(
          "div",
          { ref: "modal", staticClass: "b-modal-content" },
          [
            _vm.showCloseButton
              ? _c(
                  "span",
                  {
                    class: [
                      "close-trigger",
                      { "close-opacity": _vm.disableCloseButtonOpacity }
                    ],
                    on: { click: _vm.close }
                  },
                  [
                    _c("XIcon", {
                      attrs: {
                        color: _vm.closeButtonColor,
                        translucid: _vm.enableTranslucidCloseButton
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }